import { defineSong } from '../types';

export default defineSong({
  id: 'sehir-isiklari',
  title: 'Şehir Işıkları',
  level: 3,
  key: 'Em',
  bpm: 98,
  beats: 4,
  pattern: 'D-DU-UDU',
  style: 'Pop rock',
  desc: '{{pc:E}} minörde i–VI–III–VII. Kıtanın sonunda dominant {{c:B7}} gerilimi bekliyor.',
  palette: ['Em', 'G', 'Am', 'B7', 'C', 'D', 'Bm', 'E'],
  sections: [
    { name: 'Giriş', bars: ['Em', 'C', 'G', 'D'] },
    { name: 'Kıta', bars: ['Em', 'C', 'G', 'D', 'Em', 'C', 'B7', 'B7'] },
    { name: 'Nakarat', bars: ['C', 'D', 'G', 'Em', 'C', 'D', 'B7', 'Em'] },
  ],
  // Original lyrics written for kulaktan.com; each word with its length in beats.
  lyrics: [
    { bar: 5, text: 'Kalabalıkta:3 kayboldum:3 yine:2' },
    { bar: 7, text: 'Kornalar,:3 adımlar,:3 yağmur:2' },
    { bar: 9, text: 'Vitrinlerde:3 yansıyan:3 yüzler:2' },
    { bar: 11, text: 'Hiçbiri:2 senin:2 gibi:2 değil:2' },
    { bar: 13, text: 'Şehir:2 ışıkları:4 yanar:2' },
    { bar: 15, text: 'Her:1 biri:2 bir:1 pencere:4' },
    { bar: 17, text: 'Birinde:3 sen:1 varsın:2 belki:2' },
    { bar: 19, text: 'Bu:1 gece:2 bulurum:3 seni:2' },
  ],
});
